import { ReactElement, useContext } from "react";
import "./CheckOutPayment.css";
import { Raw } from "../../App";
import { currency } from "../../utilities/misc";
import { LocaleContext } from "../../AppProvider";

export const CheckOutPaymentLeft = ({
  TotalDeposit,
  depositUnavailable,
  children
}: {
  TotalDeposit: number;
  depositUnavailable: boolean;
  children: string | ReactElement;
}) => {
  const { t, locale } = useContext(LocaleContext);

  return (
    <>
      <p className="checkout_payment_info">Book with confidence</p>
      <div className="check_out_payment_block">
        <div className="payment_type_wrapper">
          <div className="flex payment_type_info_sect">
            <div className="flex">
              <span className="payment_type_container flex1">
                <Raw>
                  {t(
                    "Only pay a deposit of {{amount}}. The rest can be paid in cash or card to the cleaner.",
                    {
                      "{{amount}}": `<span class="fontBlue">${
                        depositUnavailable
                          ? "..."
                          : `${currency(TotalDeposit.toFixed(2), locale)}`
                      }</span>`
                    }
                  )}
                </Raw>
              </span>
            </div>
          </div>
        </div>
        <div className="payment_method_wrapper">
          <p>{t("Payment Method")}:</p>
        </div>
        {children}
      </div>
    </>
  );
};

export default CheckOutPaymentLeft;
